<template>
    <Container class="tw-animate-pulse">
        <div class="tw-mb-5 tw-flex tw-flex-col tw-items-center tw-gap-3">
            <div class="tw-size-[120px] tw-rounded-full tw-bg-gray-300"></div>
            <span class="tw-mx-auto tw-w-fit tw-rounded-full tw-bg-gray-300 tw-px-2 tw-py-1 tw-text-xs tw-text-gray-300">Lorem ipsum dolor</span>
            <!-- title -->
            <div class="tw-text-center tw-text-lg">
                <p class="tw-inline tw-rounded-full tw-bg-gray-300 tw-font-bold tw-text-gray-300">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lacinia</p>
            </div>

            <!-- relativeDate -->
            <div class="tw-rounded-full tw-bg-gray-300 tw-text-center tw-text-xs tw-text-gray-300">00/00/0000, 00:00</div>
        </div>
        <article class="tw-mb-5">
            <div class="tw-text-left tw-text-xs">
                <p class="tw-inline tw-rounded-full tw-text-justify tw-bg-gray-300 tw-text-gray-300 tw-leading-loose">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lacinia, mauris quis posuere accumsan, ligula purus aliquam arcu, aliquam pellentesque felis tortor eu elit. Duis massa nisi, varius vitae tincidunt nec, elementum at est. Morbi sed elit in arcu suscipit fermentum. Donec sodales molestie egestas. Phasellus molestie feugiat leo, non maximus nunc fermentum in. Sed sem purus, facilisis vitae diam vitae, posuere pulvinar felis. Morbi id nisi eget mi tincidunt elementum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lacinia, mauris quis posuere accumsan, ligula purus aliquam arcu, aliquam pellentesque felis tortor eu elit. Duis massa nisi, varius vitae tincidunt nec, elementum at est. Morbi sed elit in arcu suscipit fermentum. Donec sodales molestie egestas. Phasellus molestie feugiat leo, non maximus nunc fermentum in. Sed sem purus, facilisis vitae diam vitae, posuere pulvinar felis. Morbi id nisi eget mi tincidunt elementum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed lacinia, mauris quis posuere accumsan, ligula purus aliquam arcu, aliquam pellentesque felis tortor eu elit.
                </p>
            </div>
        </article>
    </Container>
</template>

<script setup lang="ts"></script>

<style scoped>
    h1,
    p {
        display: inline;
    }
</style>
